import React, { useEffect, useState } from "react";
import MainLayout from "../components/MainLayout";
import GridPage from "../components/GridPage";
import InputText from "../ReusableComponents/InputText";
import DropDown from "../ReusableComponents/DropDown";
import Buttons from "../components/Buttons";
import { mainTable } from "../css/Common";
import { moduleHeader } from "../components/HeaderAttribute";
import TextArea from "../ReusableComponents/TextArea";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { BindAPI, IUDAPI } from "../services/APIConnection";
import AddScreenTitle from "../components/AddScreenTitle";
import MainPopup from "../popup-containers/MainPopup";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import ModulePopup from "../popup-containers/ModulePopup";
import PopUpButtons from "../components/PopUpButtons";
import Loader from "../ReusableComponents/Loader";
import ErrorPopup from "../ReusableComponents/ErrorPopup";

const Module = () => {
  const location = useLocation();
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [rowIndex, setRowIndex] = useState("");
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [moduleDatas, setMopduleDatas] = useState("");
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [moduleId, setModuleId] = useState("");
  const [formFields, setFormFields] = useState({
    moduleName: "",
    relevance: "",
    coverage: 1,
    remarks: "",
  });

  const [formFieldsErrors, setFormFieldsErrors] = useState({
    moduleNameErrors: "",
    relevanceErrors: "",
    coverageErrors: "",
    remarksErrors: "",
  });
  const [bindModuleData, setBindModuleData] = useState([]);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);

  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
    localStorage.setItem("screenMode", "add");
  };

  const handleDropdownChange = (name, value) => {
    setFormFields((prev) => ({
      ...prev,
      [name]: value.target.value,
    }));
  };
    const fetchModule = async () => {
    setIsLoading(true);
    try {
      const response = await BindAPI("ModuleAPI/BindModules");
      setBindModuleData(response?.data?.Table || []);
       if (response?.data?.Table.length > 0) {
      setVisibleTable(true);
      setVisibleAdd(false);
    } else {
      showAdd();
    }
    } catch (error) {
      console.error("Error fetching modules:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchModule();
  }, []);

  const handleEdit = async (rowIndex) => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setUpdateScreenTitle(true);
    setAddScreenTitle(false);
    localStorage.setItem("screenMode", "edit");
    localStorage.setItem("selectedRowIndex", rowIndex); // store index
    setFormFields({
      ...formFields,
      moduleName: bindModuleData[rowIndex].ModuleName,
      relevance: bindModuleData[rowIndex].Relevance,
      coverage: bindModuleData[rowIndex].Coverage,
      remarks: bindModuleData[rowIndex].Remarks,
    });
    setModuleId(bindModuleData[rowIndex].MstModuleId);
  };

  const handleModule = (rowIndex, flag) => {
    setpopUpOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(true);
    }
    setMopduleDatas(bindModuleData[rowIndex]);
  };
  const cancel = () => {
    setIsLoading(false);
    fetchModule();
    setVisibleAdd(false);
    setVisibleTable(true);
    setpopUpOpen(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setSubmitBtnDisabled(false);
    setFormFields({
      moduleName: "",
      relevance: "",
      coverage: 1,
      remarks: "",
    });

    setFormFieldsErrors({
      moduleNameErrors: "",
      relevanceErrors: "",
      coverageErrors: "",
      remarksErrors: "",
    });
    localStorage.setItem("screenMode", "");
  };
  const createdBy = sessionStorage.getItem("createdBy");
  const handleSubmit = async (items, flag) => {
    setSubmitBtnDisabled(true);
    if (flag === 1 || flag === 2) {
      const isFormError = {
        ...formFieldsErrors,
        moduleNameErrors:
          formFields.moduleName && formFields.moduleName.length > 0
            // ? /^[A-Za-z.'&,\- ]+$/.test(formFields.moduleName)
              ? ""
              // : "Only alphabets and allowed special characters (.',-&) are permitted"
            : "Enter Module Name",
        relevanceErrors:
          formFields.relevance && formFields.relevance > 0
            ? ""
            : "Select Relevance",
      };
      
      setFormFieldsErrors(isFormError);
      const isFormValid = Object.values(isFormError).every(
        (error) => error === ""
      );
      if (isFormValid) {
        setIsLoading(true);
        setSubmitBtnDisabled(true);
        const modulePayload = [
          {
            mstModuleId: moduleId ? moduleId : 0,
            moduleName: formFields.moduleName,
            relevance: formFields.relevance,
            coverage: formFields.coverage,
            remarks: formFields.remarks,
            createdby: createdBy,
            flag: flag,
          },
        ];

        const response = await IUDAPI(modulePayload, "ModuleAPI/IUDmodule");
        if (flag === 1) {
          if (response.data.Table[0].Result === "S") {
            toast.success("Module added successfully 👍", {
              duration: 5000,
              position: "top-center",
            });
            setTimeout(cancel, 5000);
          } else {
            toast.error("Failed to add module 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        } else if (flag === 2) {
          if (response.data.Table[0].Result === "M") {
            toast.success("Module updated successfully 👍", {
              duration: 5000,
              position: "top-center",
            });
            setTimeout(cancel, 5000);
          } else {
            toast.error("Failed to update module 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        }
      } else {
        setIsLoading(false);
        setIsOpen(true);
        setSubmitBtnDisabled(false);
      }
    } else {
      const data = {
        mstModuleId: bindModuleData[items].MstModuleId,
        createdBy: createdBy,
        flag: flag,
      };
      const response = await IUDAPI([data], "ModuleAPI/IUDmodule");
      const result = response.data.Table[0].Result;
      if (flag === 3 && result === "D") {
        toast.success("Module deleted successfully 🗑️", {
          duration: 5000,
          position: "top-center",
        });
        cancel();
      } else if (flag === 4 && result === "B") {
        toast.success("Module inactivated successfully ✅", {
          duration: 5000,
          position: "top-center",
        });
        cancel();
      } else if (flag === 5 && result === "UB") {
        toast.success("Module activated successfully 🔄", {
          duration: 5000,
          position: "top-center",
        });
        cancel();
      } else {
        toast.error("Module action failed 👎", {
          duration: 2000,
          position: "top-center",
        });
        setTimeout(cancel, 2000);
      }
    }
  };

  useEffect(() => {
    if (location.pathname === "/module") {
      const screenMode = localStorage.getItem("screenMode");
      if (screenMode === "add") {
        setVisibleAdd(true);
        setVisibleTable(false);
        setAddScreenTitle(true);
        setUpdateScreenTitle(false);
      } else if (screenMode === "edit") {
        const storedIndex = localStorage.getItem("selectedRowIndex");
        if (storedIndex !== null && bindModuleData.length > 0) {
          handleEdit(Number(storedIndex));
        }
      }
    }
  }, [location, bindModuleData]);

  return (
    <MainLayout pageName={"2"}>
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && !isLoading &&(
        <GridPage
          title="Module"
          header={moduleHeader}
          records={bindModuleData}
          blockView={true}
          handleEdit={handleEdit}
          handleAction={handleModule}
          showAdd={showAdd}
        />
      )}
      {visibleAdd && (
        <>
          <div className="flex flex-col w-full">
            <div className={mainTable.clientMasterMainAdd}>
              <AddScreenTitle
                addScreenTitle={addScreenTitle}
                updateScreenTitle={updateScreenTitle}
                title="Module"
              />
            </div>
          </div>

          <div className=" overflow-auto p-5 min-h-[60vh] max-h-[72vh]">
            <div className="">
              <div className={mainTable.grid2}>
                <InputText
                  inputType="text"
                  title="Module Name"
                  name="moduleName"
                  maxLength={200}
                  classStar="text-red-500"
                  controlFunc={(e) => {
                    setFormFields({
                      ...formFields,
                      moduleName: e.target.value,
                    });
                  }}
                  disabled={false}
                  content={formFields.moduleName}
                  controlFuncBlur={() => {
                    setFormFieldsErrors(() => ({
                      ...formFieldsErrors,
                      moduleNameErrors:
                        formFields.moduleName &&
                        formFields.moduleName.length > 0
                          // ? /^[A-Za-z.'&,\- ]+$/.test(formFields.moduleName)
                            ? ""
                            // : "Only alphabets and allowed special characters (.',-&) are permitted"
                          : "Enter Module Name",
                    }));
                  }}
                  errorMessage={formFieldsErrors.moduleNameErrors}
                />
                <div>
                  <DropDown
                    name="relevance"
                    title="Relevance"
                    classStar="text-red-500"
                    selectedOption={formFields.relevance}
                    options={[
                      { value: 1, label: "Applicable" },
                      { value: 2, label: "Not-Applicable" },
                    ]}
                    placeholder="Select Applicable / Not-Applicable"
                    tabIndex={1}
                    disabled={false}
                    controlFunc={(val) =>
                      handleDropdownChange("relevance", val)
                    }
                    controlFuncBlur={() => {
                      setFormFieldsErrors(() => ({
                        ...formFieldsErrors,
                        relevanceErrors: formFields.relevance
                          ? ""
                          : "Select Relevance",
                      }));
                    }}
                  />
                  {formFieldsErrors && (
                    <span class="text-red-500 text-sm font-medium">
                      {formFieldsErrors.relevanceErrors}
                    </span>
                  )}
                </div>
              </div>
              <div>
                <TextArea
                  title="Remarks"
                  content={formFields.remarks}
                  maxLength={500}
                  controlFunc={(e) => {
                    setFormFields({
                      ...formFields,
                      remarks: e.target.value,
                    });
                  }}
                />
              </div>

              <div className="flex justify-center mt-6">
                <Buttons
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                  handleSubmit={handleSubmit}
                  cancel={cancel}
                  disabledBtn={submitBtnDisabled ? true : false}
                />
              </div>
            </div>
          </div>
        </>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={() => setpopUpOpen(true)}
      >
        <div>
          <PopUpScreenTitle
            title="Module"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <ModulePopup data={moduleDatas} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default Module;
